angular.module('impactx.search').service('SearchFilterStorage', [
    '$timeout',
    SearchFilterStorage
]);

function SearchFilterStorage($timeout) {
    var currentFilter = null;
    var freshFilter = null;
    var globalFilter = null;
    var vCatFilters = [];
    var lotFilters = [];
    var tenderListFilters = [];
    var lotListFilters = [];
    var vCatListFilters = [];
    var supplierListFilters = [];
    var tenderFilters = [];
    var supplierFilters = [];
    var manufacturerFilters = [];
    var searchFilterPlaceHolder = null;
    var canResetSearchInput = false;
    var savedScrollPositions = {};
    var facetFilters = [];

    function setCurrentFilter(filter) {
        currentFilter = filter;
    }

    function getCurrentFilter() {
        return currentFilter;
    }

    function setVCatFilter(id, filterObject) {
        vCatFilters[id] = filterObject;
    }

    function getVCatFilter(id) {
        return vCatFilters[id];
    }

    function setLotFilter(id, filterObject) {
        lotFilters[id] = filterObject;
    }

    function getLotFilter(id) {
        return lotFilters[id];
    }

    function setTenderListFilter(filterObject) {
        tenderListFilters.push(filterObject);
    }

    function getTenderListFilter() {
        return tenderListFilters[tenderListFilters.length - 1];
    }

    function removeLastTenderListFilter() {
        return tenderListFilters.pop();
    }

    function setLotListFilter(filterObject) {
        lotListFilters.push(filterObject);
    }

    function getLotListFilter() {
        return lotListFilters[lotListFilters.length - 1];
    }

    function removeLastLotListFilter() {
        return lotListFilters.pop();
    }

    function setVCatalogListFilter(filterObject) {
        vCatListFilters.push(filterObject);
    }

    function getVCatalogListFilter() {
        return vCatListFilters[vCatListFilters.length - 1];
    }

    function removeLastVCatalogListFilter() {
        return vCatListFilters.pop();
    }

    function setSupplierListFilter(filterObject) {
        supplierListFilters.push(filterObject);
    }

    function getSupplierListFilter() {
        return supplierListFilters[supplierListFilters.length - 1];
    }

    function removeLastSupplierListFilter() {
        return supplierListFilters.pop();
    }

    function setTenderFilter(id, filterObject) {
        tenderFilters[id] = filterObject;
    }

    function getTenderFilter(id) {
        return tenderFilters[id];
    }

    function setSupplierFilter(id, filterObject) {
        supplierFilters[id] = filterObject;
    }

    function getSupplierFilter(id) {
        return supplierFilters[id];
    }

    function setManufacturerFilter(id, filterObject) {
        manufacturerFilters[id] = filterObject;
    }

    function getManufacturerFilter(id) {
        return manufacturerFilters[id];
    }

    function setFreshFilter(freshFilterToSet) {
        if (freshFilterToSet) {
            freshFilterToSet.forProductView = false;
            freshFilter = JSON.parse(JSON.stringify(freshFilterToSet));
        }
    }

    function getFreshFilter() {
        return freshFilter ? JSON.parse(JSON.stringify(freshFilter)) : null;
    }

    function setGlobalFilter(globalFilterToSet) {
        globalFilter = globalFilterToSet;
    }

    function getGlobalFilter() {
        return globalFilter;
    }

    function reset() {
        freshFilter = null;
        globalFilter = null;
        vCatFilters = [];
        lotFilters = [];
        tenderFilters = [];
        supplierFilters = [];

        tenderListFilters = [];
        lotListFilters = [];
        vCatListFilters = [];
        supplierListFilters = [];
    }

    function setSearchFilterPlaceHolder(searchFilterPlaceHolderToSet) {
        searchFilterPlaceHolder = searchFilterPlaceHolderToSet;
        if (!searchFilterPlaceHolder) {
            setCanResetSearchInput(false);
        }
    }

    function getSearchFilterPlaceHolder() {
        return searchFilterPlaceHolder;
    }

    function setCanResetSearchInput(canResetSearchInputToSet) {
        canResetSearchInput = canResetSearchInputToSet;
    }

    function getCanResetSearchInput() {
        return canResetSearchInput;
    }

    function getScrollPosition(id) {
        return savedScrollPositions[id];
    }

    function setScrollPosition(id, value) {
        return savedScrollPositions[id] = value;
    }

    function scrollToScrollPosition(id, targetHtmlId)
    {
        if(getScrollPosition(id))
        {
            $timeout(() => {
                angular.element(targetHtmlId).scrollTop(getScrollPosition(id));
                delete savedScrollPositions[id];
            }, 0);
        }
    }

    function setFacetFilter(facets) {
        facetFilters = facets;
    }

    function getFacetFilter() {
        return facetFilters;
    }

    return {
        setVCatFilter: setVCatFilter,
        getVCatFilter: getVCatFilter,
        setLotFilter: setLotFilter,
        getLotFilter: getLotFilter,
        setTenderListFilter: setTenderListFilter,
        getTenderListFilter: getTenderListFilter,
        removeLastTenderListFilter: removeLastTenderListFilter,
        setLotListFilter: setLotListFilter,
        getLotListFilter: getLotListFilter,
        removeLastLotListFilter: removeLastLotListFilter,
        setVCatalogListFilter: setVCatalogListFilter,
        getVCatalogListFilter: getVCatalogListFilter,
        removeLastVCatalogListFilter: removeLastVCatalogListFilter,
        setSupplierListFilter: setSupplierListFilter,
        getSupplierListFilter: getSupplierListFilter,
        removeLastSupplierListFilter: removeLastSupplierListFilter,
        setTenderFilter: setTenderFilter,
        getTenderFilter: getTenderFilter,
        setSupplierFilter: setSupplierFilter,
        getSupplierFilter: getSupplierFilter,
        setManufacturerFilter: setManufacturerFilter,
        getManufacturerFilter: getManufacturerFilter,
        setFreshFilter: setFreshFilter,
        getFreshFilter: getFreshFilter,
        setGlobalFilter: setGlobalFilter,
        getGlobalFilter: getGlobalFilter,
        reset: reset,
        getSearchFilterPlaceHolder: getSearchFilterPlaceHolder,
        setSearchFilterPlaceHolder: setSearchFilterPlaceHolder,
        getCanResetSearchInput: getCanResetSearchInput,
        setCanResetSearchInput: setCanResetSearchInput,
        getCurrentFilter: getCurrentFilter,
        setCurrentFilter: setCurrentFilter,
        setSearchScrollPosition: setScrollPosition,
        getSearchScrollPosition: getScrollPosition,
        scrollToSearchScrollPosition: scrollToScrollPosition,
        setFacetFilter: setFacetFilter,
        getFacetFilter: getFacetFilter,
    };
}
